var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save-2 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4272 6.62402H5.32308C3.54183 6.62402 2.0835 8.08236 2.0835 9.86361V21.6969C2.0835 23.2073 3.16683 23.8532 4.48975 23.1136L8.5835 20.8323C9.021 20.5928 9.72933 20.5928 10.1564 20.8323L14.2502 23.1136C15.5835 23.8428 16.6668 23.2073 16.6668 21.6969V9.86361C16.6668 8.08236 15.2085 6.62402 13.4272 6.62402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.9165 5.82308V17.6564C22.9165 19.1668 21.8332 19.8022 20.5103 19.0731L18.4999 17.9481C18.3332 17.8543 18.229 17.6772 18.229 17.4897V9.86475C18.229 7.21891 16.0728 5.06266 13.427 5.06266H9.18742C8.802 5.06266 8.53117 4.65641 8.70825 4.32308C9.24992 3.29183 10.3332 2.5835 11.5728 2.5835H19.677C21.4582 2.5835 22.9165 4.04183 22.9165 5.82308Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.e62ce98a4d56565f5c92d326c97d264e.svg";
export { ForwardRef as ReactComponent };